import { Container } from '../../Container/Container';
import styles from './DocumentationPage.module.scss';

const DocumentationPage = () => {
  return (
    <div className={styles.DocumentationPage}>
      <Container>
        <h1>Информационное письмо</h1>
        <div className={styles.content_holder}>
          <div className={styles.text_holder}>
            <div className={styles.DocumentationPage_alert}>
              <div className={styles.alert_holder}>
                <img src="/icons/warning.svg" alt="warning" />
                <p>
                  Важно: Информационный характер сайта и отказ от
                  ответственности
                </p>
              </div>
            </div>

            <p>
              Добро пожаловать на информационный сайт, посвящённый продукции ЗАО
              «Группа СЕБ-Восток».
            </p>
            <p>
              <b>
                Обратите внимание: данный сайт носит исключительно
                информационный характер.
              </b>
            </p>
            <p>
              Вся размещённая на сайте информация, включая техническую
              документацию, описание запасных частей и инструкции, предназначена
              только для ознакомления и не является руководством к действию для
              самостоятельного ремонта.
            </p>
            <p>
              <b>
                Самостоятельный ремонт или установка запасных частей без участия
                специалистов может привести к повреждению изделия, утрате
                гарантии и нарушению норм безопасности.
              </b>
            </p>
            <p>
              ЗАО «Группа СЕБ-Восток» не несёт ответственности за любые
              последствия, возникшие в результате самостоятельного вмешательства
              в технику.
            </p>
            <p>
              <b>
                Заказ оригинальных запасных частей и проведение ремонта возможно
                исключительно через авторизованные сервисные центры.
              </b>
            </p>
            <p>
              Только официальные сервисные партнёры обладают необходимой
              квалификацией, инструментами и доступом к оригинальным
              комплектующим, что позволяет обеспечить качество и безопасность
              обслуживания.
            </p>
            <p>
              Список авторизованных сервисных центров доступен в соответствующем
              разделе сайта.
            </p>
          </div>
          <div className={styles.image_holder}>
            <div className={styles.img}>
              <img src={'/images/documentation/logo.svg'} alt="company image" />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DocumentationPage;
